<template>
    <div class="">
        <div class="button-div">
            <el-button :disabled="xorJudgment(newaddp_dis)" type="primary" @click="newaddp">新增一级菜单</el-button>
            <el-button :disabled="xorJudgment(newaddc_dis)" type="primary" @click="newaddc">新增子集</el-button>
            <el-button :disabled="xorJudgment(edit_dis)" type="primary" @click="edit">编辑</el-button>
            <el-button :disabled="xorJudgment(deleteItem_dis)" type="primary" @click="deleteItem">删除</el-button>
            <el-button :disabled="xorJudgment(deleteAll_dis)" type="primary" @click="deleteAll">删除所有菜单项</el-button>
            <el-button :disabled="xorJudgment(moveUp_dis)" type="primary" @click="moveUp">上移</el-button>
            <el-button :disabled="xorJudgment(moveDown_dis)" type="primary" @click="moveDown">下移</el-button>
            <el-button :disabled="xorJudgment(importMenu_dis)" type="primary" @click="importMenu">导入</el-button>
            <el-button :disabled="xorJudgment(exportMenu_dis)" type="primary" @click="exportMenu">导出</el-button>
        </div>
        <div class="content-div">
            <MenuBar :menuData="MenuBarData" @itemClick="menuDomClick" :accordion="true"></MenuBar>
        </div>

        <ModalEI v-if="showModal" v-model:visible="showModal" v-model:titleValue="titleValue"
            @close="showModal = false">
            <MenuEl @save="onEditSave" @close="showModal = false" v-model:MenuData="MenuData" v-model:Types="Types" />
        </ModalEI>
    </div>
</template>

<script>
import request from '@/utils/request' // 就写这一行

export default {
    name: 'MenuPage',
    props: {},
    data() {
        return {
            newaddc_dis: 0b0100000000,
            newaddp_dis: 0b1000000000,
            edit_dis: 0b0010000000,
            deleteItem_dis: 0b0001000000,
            deleteAll_dis: 0b0000100000,
            importMenu_dis: 0b0000010000,
            exportMenu_dis: 0b0000001000,
            moveUp_dis: 0b0000000100,
            moveDown_dis: 0b0000000010,
            submitMenu_dis: 0b0000000001,
            MenuBarData: [],
            binaryNumber: 0b1011000110, // 初始值为二进制数字组成的字符串或数字
            judgmentMode: ['disabled', 'use', 'default'],
            defaultBinaryNumber: 0b1011000110,
            showModal: false,
            titleValue: '',
            MenuData: {},
            Types: '',
            dataStandard: { //数据标准
                'Types': 'pc',
                'MeanName': '',
                'Route': '',
                'MeanLevel': 0,
                'Sort': 0,
                'ParentID': '',
                'ChildOrNot': 0,
                'Icon': '',
                'Address': location.href,
                'ID': '',
                'parentMenu': { 'name': '', 'ID': '' },
            },
            saveState: true
        }
    },
    methods: {
        newaddp() {
            console.log('新增父级');
            this.MenuData = this.dataStandard;
            this.MenuData.MeanLevel = 1;
            if (this.MenuBarData.length == 0) {
                this.MenuData.Sort = 1;
            }
            this.showModal = true;
            this.titleValue = '新增父级菜单';
            this.Types = 'addParent';

        },
        newaddc() {
            console.log('新增子集');
            this.MenuData.parentMenu = { 'name': this.$messageX.recursiveDeepSearch(this.MenuBarData, 'ID', this.MenuData.ParentID), 'ID': this.MenuData.ParentID };
            this.showModal = true;
            this.titleValue = '新增子级菜单';
            this.Types = 'addSub';
        },
        edit() {
            console.log('编辑');
            this.showModal = true;
            this.titleValue = '编辑菜单';
            this.Types = 'edit';
        },
        deleteItem() {
            console.log('删除');
            this.$messageX.tipWin({ "magess": "确定删除选中菜单数据？", "magess_title": "提示" }, this.exitGroupf, this.emptyFunction);
        },
        async exitGroupf() {
            console.log('删除选中菜单数据');
            if (this.MenuData.ID) {
                try {
                    const res = await request.post('/DeleteMenuData', {
                        ID: this.MenuData.ID
                    });
                    this.$messageX.xiaoxiti("c", res.message);
                    this.obtainMenuBarData();

                } catch (err) {
                    console.log('失败:', err)
                    if (err.response.data.message) {
                        this.$messageX.xiaoxiti("e", err.response.data.message);
                    } else {
                        this.initData();
                        this.$messageX.xiaoxiti("e", err.message);
                    }
                }
            } else {
                this.$messageX.xiaoxiti("e", "未选中菜单数据");
            }
        },
        deleteAll() {
            console.log('删除所有菜单项');
            this.$messageX.tipWin({ "magess": "确定删除本后台的所有菜单数据？", "magess_title": "提示" }, this.deleteAllApi, this.emptyFunction);
        },
        importMenu() {
            console.log('导入');
        },
        emptyFunction() {

        },
        exportMenu() {
            console.log('导出');
        },
        async obtainMenuBarData() {
            console.log('获取菜单数据');
            try {
                const res = await request.post('/ObtainMenuData', {
                    address: location.href,
                    Short: 'pc'
                });
                this.$messageX.xiaoxiti("c", res.message);
                this.MenuBarData = res.response.data;
                this.saveState = true;

            } catch (err) {
                console.log('失败:', err)
                if (err.response.data.message) {
                    this.$messageX.xiaoxiti("e", err.response.data.message);
                } else {
                    this.initData();
                    this.$messageX.xiaoxiti("e", err.message);
                }
            }
        },
        menuDomClick(data) {
            console.log('点击菜单');
            console.table(data);
            this.MenuData = data;
        },
        moveUp() {
            console.log('上移');
        },
        moveDown() {
            console.log('下移');
        },
        controlDisabled(binaryNumber, mode) { // 控制按钮的禁用状态，参数为二进制数字组成的字符串或数字
            let typeofValue = typeof (binaryNumber);
            if (typeofValue != 'number' && typeofValue != 'string') {
                console.error('controlDisabled方法的参数必须是数字或字符串类型');
                this.$messageX.xiaoxiti("e", "参数必须是数字或字符串类型");
                return;
            }
            let numberValueList = String(binaryNumber).split('');
            let numberCheckList = numberValueList.filter(item => Number(item) === 1 ? true : (Number(item) === 0 ? true : console.error('controlDisabled方法的参数必须是二进制数字组成的字符串或数字')));
            if (numberCheckList.length != numberValueList.length) {
                this.$messageX.xiaoxiti("e", "参数存在非二进制数字，请检查参数");
                return false;
            }
            if (!this.judgmentMode.includes(mode)) {
                this.$messageX.xiaoxiti("e", "非法模式参数！");
                return false;
            }
            if (mode == 'disabled') {
                this.binaryNumber = this.binaryNumber | Number(binaryNumber);
            } else if (mode == 'use') {
                this.binaryNumber = this.binaryNumber ^ Number(binaryNumber);
            } else if (mode == 'default') {
                this.binaryNumber = this.defaultBinaryNumber;
            }
        },
        xorJudgment(value) {
            return (this.binaryNumber & value) === 1;
        },
        onEditSave(formData) {
            console.log(formData);
            if (formData.response) {
                this.obtainMenuBarData();
            }
        },
        shortOr(list, dict) {
            list.sort((a, b) => a.Sort - b.Sort);
            if (!dict[0].Short || dict[0].Short.trim() === '') {
                dict[0].Short = list.length + 1;
                list.push(dict[0]);
            } else {
                const existingIndex = list.findIndex(item => item.Short === dict[0].Short);
                if (existingIndex !== -1) {
                    list[existingIndex] = dict[0];
                } else {
                    for (let i = existingIndex; i <= list.length; i++) {
                        list[i].Short = i + 1;
                    }
                    list[existingIndex] = dict[0];
                }
            }
            list.sort((a, b) => a.Sort - b.Sort);
        },
        async deleteAllApi() {
            try {
                const res = await request.post('/DeleteAllMenuData', {
                    Types: this.form.Types,
                    TypesID: this.form.TypesID,
                    Address: this.form.Address
                });
                this.$messageX.xiaoxiti("c", res.message);
                this.obtainMenuBarData();

            } catch (err) {
                console.log('失败:', err)
                if (err.response.data.message) {
                    this.$messageX.xiaoxiti("e", err.response.data.message);
                } else {
                    this.initData();
                    this.$messageX.xiaoxiti("e", err.message);
                }
            }
        },

    },
    mounted() {
        this.obtainMenuBarData();
        this.binaryNumber = this.defaultBinaryNumber;
    },
    beforeUnmount() {
        if (!this.saveState) {
            this.$messageX.tipWin({ "magess": "页面中还存在未保存的数据，关闭后编辑的数据将会？", "magess_title": "提示" }, this.exitGroupf, this.emptyFunction);
        }
    },
}
</script>

<style scoped>
.public-css-var {
    --button-div-height: 100px;
}

.button-div {
    width: 100%;
    height: var(--button-div-height);
}

.content-div {
    width: 100%;
    height: calc(100% - var(--button-div-height));
}
</style>